module.exports = __webpack_public_path__ + "static/media/fatsoma-tabb-logo.64371582.svg";


//////////////////
// WEBPACK FOOTER
// ./src/utils/images/fatsoma-tabb-logo.svg
// module id = 259
// module chunks = 1